import { useEffect } from 'react';
import { useTheme } from 'next-themes';

/**
 * Hook to synchronize the theme-color meta tag with the current theme
 */
export function useThemeSync() {
  const { theme, resolvedTheme } = useTheme();

  useEffect(() => {
    // Use resolvedTheme which gives us the actual theme (not 'system')
    const currentTheme = resolvedTheme || theme;
    
    // Update theme-color meta tag
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      const themeColor = currentTheme === 'dark' ? '#171717' : '#ffffff';
      metaThemeColor.setAttribute('content', themeColor);
    }
  }, [theme, resolvedTheme]);
}